import React, {Fragment, useContext} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getMessagingRouterLink} from "root/Wieldy/routePaths";
import GlobalContext from "root/contexts/GlobalContext";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {MessageFilters, MessageMenuTitles, MessageType} from "root/DataFunctions/Constants";
import {useRecoilValue} from "recoil";
import {unReadMessageCountAtom} from "root/recoil/unReadMessageCount";
import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";
import useModalAddPost from "root/Modals/AddPost/useModalAddPost";

const MessagingSubmenu = (props ) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);
    // Ensure we always have a default message filter ( From the URL or a default )
    const message_filter_type = queryParams.type === undefined ? MessageFilters.INCOMING : queryParams.type;
    const shouldShowToDropdown = true;

    // Open add message modal
    const [renderAddMessagingModal, showAddMessagingModal] = useModalAddPost((result) =>
    {
        if (result === 'saved')
        {
            const path = location.pathname + '?type=' + message_filter_type;
            location.replace(path);
        }
    })

    const getUnReadMessageCount = () =>
    {
        let unReadMessageCount = useRecoilValue(unReadMessageCountAtom);
        unReadMessageCount = unReadMessageCount === 0 ? '' : unReadMessageCount;
        return unReadMessageCount;
    }

    const clickHandler = (event) =>
    {
        showAddMessagingModal('create', null, null, shouldShowToDropdown, MessageType.MESSAGE_TYPE_MESSAGE);
    }

    const messagingSubmenu = (props) =>
    {
        return (
            <Fragment>
                <AppSidebarGroup title='Filters' default={message_filter_type}>
                    <AppSidebarMenuItem link={getMessagingRouterLink('messaging?type=' + MessageFilters.INCOMING )} title={MessageMenuTitles.INCOMING} iconName='icon-inbox' name={MessageFilters.INCOMING} count = {getUnReadMessageCount()} />
                    {/*<AppSidebarMenuItem link={getMessagingRouterLink('messaging?type=' + MessageFilters.PENDING )} title={MessageMenuTitles.PENDING} iconName='icon-important' name={MessageFilters.PENDING}/>*/}
                    <AppSidebarMenuItem link={getMessagingRouterLink('messaging?type=' + MessageFilters.SENT )} title={MessageMenuTitles.SENT}iconName='icon-draft' name={MessageFilters.SENT}/>
                    <AppSidebarMenuItem link={getMessagingRouterLink('messaging?type=' + MessageFilters.DRAFT )} title={MessageMenuTitles.DRAFT} iconName='icon-edit' name={MessageFilters.DRAFT}/>
                    {/*<AppSidebarMenuItem link={getMessagingRouterLink('messaging?type=' + MessageFilters.ALL)} title={MessageMenuTitles.ALL} iconName='icon-chat' name={MessageFilters.ALL}/>*/}
                </AppSidebarGroup>

                <WieldySidebarSection title='New Message' >
                    <WieldySidebarClick modal={(event) => clickHandler(event)} title='Message' iconName='icon-add-circle' iconSize='icon-xl' keyName='root1' key='c1'/>
                </WieldySidebarSection>
            </Fragment>
        )
    }

    return (
        <Fragment>
            {messagingSubmenu()}
            {renderAddMessagingModal(props)}
        </Fragment>
    )
}

export default MessagingSubmenu ;